export default "__VITE_ASSET__9ebedf47__"